@Service('ib-ui-birth-date-module',
    [])
export class IbUiBirthdateIdentifierGeneratorService {
    private id = 0;

    generateId () {
        return `ui-birth-date-input-${this.id++}`;
    }
}
